var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaylink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.99 17.5H15.5C18.52 17.5 21 15.03 21 12C21 8.98 18.53 6.5 15.5 6.5H13.99M8 6.5H6.5C5.04212 6.50264 3.64471 7.08295 2.61383 8.11383C1.58295 9.14471 1.00264 10.5421 1 12C1 15.02 3.47 17.5 6.5 17.5H8M7 12H15",
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaylink);
export default __webpack_public_path__ + "static/media/paylink.df9a1eb9f06d38e139b9d9341d229ab4.svg";
export { ForwardRef as ReactComponent };